// Module
var code = `<div class="footer-position-exercise-request">
    <terceraButton name="exerciseBtn" 
        text="{{.exerciseBtnText}}"
        enabled="{{.exerciseBtnEnabled}}"
        tooltip="{{.exerciseBtnTooltip}}"
        terceraButtonStyle="js-button-ok" 
        on-btnClick="exerciseBtnClick" />

    <terceraButton name="cancelBtn" 
        text="{{.cancelBtnText}}"
        terceraButtonStyle="js-button-gray25" 
        on-btnClick="cancelBtnClick" />
</div>`;
// Exports
export default code;